const dev = '/contact.php';

class ContactPHP {
  saveData = (values) => {
    console.log(values.name);
    fetch(dev, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name: values.name,
        email: values.email,
        message: values.message,
      }),
    })
      .then(response => response.json())
      .then((responseJson) => {
        console.log(responseJson);
        return true;
      })
      .catch((error) => {
        console.log(error);
        return false;
      });
  };
}

export default ContactPHP;



// WEBPACK FOOTER //
// ./src/helper/ContactPHP.js